// Keycloak configuration for the frontend
export const keycloakConfig = {
  url: import.meta.env.VITE_KEYCLOAK_URL || '',
  realm: import.meta.env.VITE_KEYCLOAK_REALM || '',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || '',
} as const;
// Keycloak initialization options
export const keycloakInitOptions = {
  onLoad: 'check-sso' as const, // Check if user is already logged in
  silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
  checkLoginIframe: false, // Enable iframe check for SSO session detection
  pkceMethod: 'S256' as const, // Use PKCE for better security
} as const;
// Default configuration object for Keycloak instance
export const defaultKeycloakConfig = {
  ...keycloakConfig,
} as const;
export default keycloakConfig;
